<script>
// Taken from pretty-check-vue to allow adding validation
import prettyInput from './PrettyInputClone';

const prettyCheckbox = {
    name: "pretty-checkbox",
    inject: ['$validator'],

    input_type: 'checkbox',

    model: prettyInput.model,
    props: prettyInput.props,
    data: prettyInput.data,
    computed: prettyInput.computed,
    watch: prettyInput.watch,
    mounted: prettyInput.mounted,
    methods: prettyInput.methods,

    render: prettyInput.render,
};

export default prettyCheckbox;
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PrettyCheckClone.vue